import { Controller } from '@hotwired/stimulus';

import Local from '@/modules/local';
import ModuleLoader from '@/modules/module_loader';
import Searcher from '@/modules/searcher';
import Templates from '@/pages/site/templates';

Handlebars.registerPartial('teacher', Templates._teacher);

export default class extends Controller {
  connect() {
    const options = ModuleLoader.getOptions();

    new Searcher($('[data-gridy]'), Templates.teachers.gridy, options.gridy).create();
    new Local().create();
  }
}
